(() => {
  const header = document.querySelector(".site-header");
  const navToggle = document.querySelector("[data-nav-toggle]");
  const primaryNav = document.querySelector("#primary-navigation");

  if (header && navToggle && primaryNav) {
    const setMenu = (isOpen) => {
      header.classList.toggle("nav-open", isOpen);
      navToggle.setAttribute("aria-expanded", String(isOpen));
      navToggle.setAttribute("aria-label", isOpen ? "Close menu" : "Open menu");
    };

    navToggle.addEventListener("click", () => {
      setMenu(!header.classList.contains("nav-open"));
    });

    primaryNav.addEventListener("click", (event) => {
      if (event.target.closest("a")) {
        setMenu(false);
      }
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        setMenu(false);
      }
    });

    window.addEventListener("resize", () => {
      if (window.matchMedia("(min-width: 981px)").matches) {
        setMenu(false);
      }
    });
  }

  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  const contactModal = document.querySelector("[data-contact-modal]");

  if (contactModal) {
    const contactOpeners = Array.from(document.querySelectorAll("[data-contact-modal-open]"));
    const contactClosers = Array.from(contactModal.querySelectorAll("[data-contact-modal-close]"));
    const contactFocusableSelector = [
      "button:not([disabled])",
      "a[href]",
      "input:not([disabled])",
      "textarea:not([disabled])",
      "select:not([disabled])",
      "[tabindex]:not([tabindex='-1'])"
    ].join(",");
    let lastContactTrigger = null;

    const getContactFocusable = () => Array.from(contactModal.querySelectorAll(contactFocusableSelector));

    const closeContactModal = () => {
      if (contactModal.hidden) {
        return;
      }

      contactModal.hidden = true;
      contactModal.setAttribute("aria-hidden", "true");
      document.body.classList.remove("contact-modal-open");

      if (lastContactTrigger) {
        lastContactTrigger.focus({ preventScroll: true });
      }
    };

    const openContactModal = (trigger) => {
      lastContactTrigger = trigger;
      contactModal.hidden = false;
      contactModal.setAttribute("aria-hidden", "false");
      document.body.classList.add("contact-modal-open");

      const focusable = getContactFocusable();
      const firstInput = contactModal.querySelector("input, textarea");
      const focusTarget = firstInput || focusable[0];

      if (focusTarget) {
        focusTarget.focus({ preventScroll: true });
      }
    };

    contactOpeners.forEach((trigger) => {
      trigger.addEventListener("click", () => openContactModal(trigger));
    });

    contactClosers.forEach((closer) => {
      closer.addEventListener("click", closeContactModal);
    });

    contactModal.addEventListener("click", (event) => {
      if (event.target === contactModal) {
        closeContactModal();
      }
    });

    document.addEventListener("keydown", (event) => {
      if (contactModal.hidden) {
        return;
      }

      if (event.key === "Escape") {
        closeContactModal();
        return;
      }

      if (event.key !== "Tab") {
        return;
      }

      const focusable = getContactFocusable();

      if (!focusable.length) {
        return;
      }

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus({ preventScroll: true });
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus({ preventScroll: true });
      }
    });
  }

  const galleryModal = document.querySelector("[data-gallery-modal]");

  if (galleryModal) {
    const modalImage = galleryModal.querySelector("[data-gallery-modal-image]");
    const modalCaption = galleryModal.querySelector("[data-gallery-modal-caption]");
    const modalImageButton = galleryModal.querySelector("[data-gallery-modal-close]");
    const triggers = Array.from(document.querySelectorAll("[data-gallery-modal-trigger]"));
    let lastGalleryTrigger = null;

    const closeGalleryModal = () => {
      if (galleryModal.hidden) {
        return;
      }

      galleryModal.hidden = true;
      galleryModal.setAttribute("aria-hidden", "true");
      document.body.classList.remove("gallery-modal-open");

      if (lastGalleryTrigger) {
        lastGalleryTrigger.focus({ preventScroll: true });
      }
    };

    const openGalleryModal = (trigger) => {
      if (!modalImage || !modalCaption || !modalImageButton) {
        return;
      }

      lastGalleryTrigger = trigger;
      modalImage.src = trigger.dataset.gallerySrc || "";
      modalImage.alt = trigger.dataset.galleryAlt || "";
      modalCaption.textContent = trigger.dataset.galleryCaption || "";
      galleryModal.hidden = false;
      galleryModal.setAttribute("aria-hidden", "false");
      document.body.classList.add("gallery-modal-open");
      modalImageButton.focus({ preventScroll: true });
    };

    triggers.forEach((trigger) => {
      trigger.addEventListener("click", () => openGalleryModal(trigger));
    });

    galleryModal.addEventListener("click", (event) => {
      const clicked = event.target;

      if (!(clicked instanceof Element)) {
        return;
      }

      if (
        clicked.closest("[data-gallery-modal-close]") ||
        !clicked.closest(".gallery-modal-image-button")
      ) {
        closeGalleryModal();
      }
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Tab" && !galleryModal.hidden && modalImageButton) {
        event.preventDefault();
        modalImageButton.focus({ preventScroll: true });
      }

      if (event.key === "Escape") {
        closeGalleryModal();
      }
    });
  }

  if (!reducedMotion.matches) {
    requestAnimationFrame(() => {
      document.documentElement.classList.add("page-motion-ready");
    });

    window.addEventListener("pageshow", () => {
      document.documentElement.classList.remove("is-leaving");
    });

    document.addEventListener("click", (event) => {
      const clicked = event.target;

      if (!(clicked instanceof Element)) {
        return;
      }

      const link = clicked.closest("a[href]");

      if (
        !link ||
        event.defaultPrevented ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey ||
        link.target ||
        link.hasAttribute("download")
      ) {
        return;
      }

      const nextUrl = new URL(link.href, window.location.href);

      if (nextUrl.origin !== window.location.origin) {
        return;
      }

      const isSamePageAnchor =
        nextUrl.pathname === window.location.pathname &&
        nextUrl.search === window.location.search &&
        nextUrl.hash;

      if (isSamePageAnchor) {
        return;
      }

      event.preventDefault();
      document.documentElement.classList.add("is-leaving");

      window.setTimeout(() => {
        window.location.href = nextUrl.href;
      }, 430);
    });
  }

  if (reducedMotion.matches) {
    document.querySelectorAll(".reveal, .motion-settle").forEach((el) => {
      el.classList.add("is-visible");
    });
    return;
  }

  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
  const goldFlowSections = Array.from(document.querySelectorAll("[data-gold-flow]"));

  if (goldFlowSections.length) {
    let goldFlowFrame = null;

    const updateGoldFlow = () => {
      goldFlowFrame = null;

      goldFlowSections.forEach((section) => {
        const rect = section.getBoundingClientRect();
        const travel = Math.max(window.innerHeight + rect.height, 1);
        const progress = clamp((window.innerHeight - rect.top) / travel, 0, 1);
        const offset = Math.round((progress - 0.5) * 140);

        section.style.setProperty("--gold-flow-y", `${offset}px`);
      });
    };

    const requestGoldFlow = () => {
      if (goldFlowFrame !== null) {
        return;
      }

      goldFlowFrame = window.requestAnimationFrame(updateGoldFlow);
    };

    updateGoldFlow();
    window.addEventListener("scroll", requestGoldFlow, { passive: true });
    window.addEventListener("resize", requestGoldFlow);
  }

  const galleryLineSections = Array.from(document.querySelectorAll("[data-gallery-line-draw]"));

  if (galleryLineSections.length) {
    let galleryLineFrame = null;
    const maxGalleryLineProgress = new WeakMap();

    const updateGalleryLineProgress = () => {
      galleryLineFrame = null;

      galleryLineSections.forEach((section) => {
        const start = section.offsetTop - window.innerHeight * 0.62;
        const maxScroll = Math.max(document.documentElement.scrollHeight - window.innerHeight, 0);
        const naturalEnd = section.offsetTop + section.offsetHeight - window.innerHeight * 0.34;
        const end = Math.min(naturalEnd, maxScroll);
        const travel = Math.max(end - start, 1);
        const rawProgress = (window.scrollY - start) / travel;
        const progress = clamp(rawProgress, 0, 1);
        const previous = maxGalleryLineProgress.get(section) || 0;
        const nextProgress = Math.max(previous, progress);

        maxGalleryLineProgress.set(section, nextProgress);
        section.style.setProperty("--gallery-line-progress", nextProgress.toFixed(3));
      });
    };

    const requestGalleryLineProgress = () => {
      if (galleryLineFrame !== null) {
        return;
      }

      galleryLineFrame = window.requestAnimationFrame(updateGalleryLineProgress);
    };

    updateGalleryLineProgress();
    window.addEventListener("scroll", requestGalleryLineProgress, { passive: true });
    window.addEventListener("resize", requestGalleryLineProgress);
  }

  const protocolSections = Array.from(document.querySelectorAll("[data-protocol-scroll]"));

  if (protocolSections.length) {
    let protocolFrame = null;

    const updateProtocolProgress = () => {
      protocolFrame = null;

      protocolSections.forEach((section) => {
        const wheel = section.querySelector(".protocol-wheel");
        const steps = Array.from(section.querySelectorAll("[data-protocol-step]"));

        if (!wheel || !steps.length) {
          return;
        }

        const sectionTop = section.offsetTop;
        const sectionBottom = sectionTop + section.offsetHeight;
        const start = sectionTop - window.innerHeight * 0.45;
        const end = sectionBottom - window.innerHeight * 0.2;
        const travel = Math.max(end - start, 1);
        const rawProgress = (window.scrollY - start) / travel;
        const progress = clamp(rawProgress, 0, 1);

        wheel.style.setProperty("--protocol-progress", `${(progress * 100).toFixed(2)}%`);
        wheel.style.setProperty("--protocol-glow", (0.1 + progress * 0.22).toFixed(3));

        const activeIndex = clamp(Math.floor(progress * steps.length), 0, steps.length - 1);
        steps.forEach((step, index) => {
          step.classList.toggle("is-current", index === activeIndex);
        });
      });
    };

    const requestProtocolProgress = () => {
      if (protocolFrame !== null) {
        return;
      }

      protocolFrame = window.requestAnimationFrame(updateProtocolProgress);
    };

    updateProtocolProgress();
    window.addEventListener("scroll", requestProtocolProgress, { passive: true });
    window.addEventListener("resize", requestProtocolProgress);
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: "0px 0px -6% 0px", threshold: 0.08 },
  );

  document.querySelectorAll(".reveal, .motion-settle").forEach((el) => observer.observe(el));
})();
